import React from 'react';
import { Routes, Route } from "react-router-dom";
import ActiveInterview from "../pages/Interview/ActiveInterview"
import InterviewHistory from "../pages/Interview/InterviewHistory"
import ViewJob from '../pages/Jobs/ViewJob';
import AddJob from '../pages/Jobs/AddJob';
import JobDescription from '../pages/Jobs/JobDescription';
import JobProfileContainer from '../pages/Jobs/JobProfileContainer';
import Applicant from '../pages/Applicants/NewApplicants';
import ScreeningHistory from '../pages/Screening/ScreeningHistory';
import Dashboard from '../layouts/Home/Dashboard';
import Login from '../pages/Login/Login';
import Applicants from '../pages/Applicants/Applicants'
import AddNewApplicant from '../pages/Applicants/AddNewApplicant'
import Insights from '../pages/Insights/Insights';
import Interviews from '../pages/Interview/Interviews';
import Jobs from '../pages/Jobs/Jobs'
import ViewApplicants from '../pages/Applicants/ViewApplicants';
import JobActive from '../pages/Jobs/JobActive';
import Hire from '../pages/Hire/Hire';
import HireForm from '../pages/Hire/HireForm';
import Register from '../pages/Register/Register';
import TestQuestion from '../pages/TestQuestion/TestQuestion';
import ApplicantScreening from '../pages/Applicants/ApplicantScreening';
import InsightsContainer from '../pages/Insights/InsightsContainer';
import Test from '../pages/Test/Test';
import TestDetails from '../pages/Test/TestDetails';
import TestLogin from '../pages/TestQuestion/TestLogin';
import TestPreview from '../pages/Test/TestPreview';
import TestQuestionPreviewDetails from '../pages/TestQuestion/TestQuestionPreviewDetails';
import RoleTable from '../pages/Register/RegistrationTable/RoleTable';
import RegisterTable from '../pages/Register/RegistrationTable/RegisterTable';
import Thankyou from '../pages/TestQuestion/Thankyou';
import TaskTable from '../pages/Insights/Components/TaskTable';
import Report from '../pages/Report/Report';
import Certificate from '../pages/Hire/Certificate';


const AppRoutes: React.FC<any> = () => {


  return (
    <Routes>
      {/* @ts-ignore */}
      <Route path="/" element={<Login />} exact />
      {/* @ts-ignore */}
      <Route path="/hire/:id" element={<Hire />} exact />
      {/* @ts-ignore */}
      <Route path="/certificateX27QF0rPxLljNoAq71sgROuRuJd0A40aApO_EALw_wcB=preview/:id" element={<Certificate data={undefined} item={undefined} />} exact />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/insights" element={<Insights setActive={''} />} />
      <Route path="/tasks" element={<TaskTable pageHeader={undefined} />} />
      <Route path="/activeinterview" element={<ActiveInterview />} />
      <Route path="/interviewhistory" element={<InterviewHistory />} />
      <Route path="/newapplicant" element={<Applicant />} />
      <Route path="/screeninghistory" element={<ScreeningHistory />} />
      <Route path="/insights" element={<Insights setActive={''} />} />
      <Route path="/addNewApplicant" element={<AddNewApplicant />} />
      <Route path="/interviews" element={<Interviews />} />
      <Route path="/applicantscreening" element={<ApplicantScreening />} />
      <Route path="/applicant" element={<Applicant />} />
      <Route path="/viewapplicants/:id" element={<ViewApplicants setActive={''} setShow={false} show={false} />} />
      <Route path="/applicants" element={<Applicants setActive={''} />} />
      {/* Job */}
      <Route path="/viewjob" element={<ViewJob />} />
      <Route path="/jobs" element={<Jobs />} />
      <Route path="/jobs/addJob" element={<AddJob />} />
      <Route path="/jobs/description" element={<JobDescription />} />
      <Route path="/JobProfileContainer" element={<JobProfileContainer />} />
      <Route path="/activejob" element={<JobActive setActive={undefined} setJobLenght={undefined} data={undefined} isLoading={undefined} message={undefined} isError={undefined} />} />
      <Route path="/hireform" element={<HireForm />} />
      <Route path="/register" element={<Register />} />
      <Route path="/testdetails/:id" element={<TestDetails />} />
      <Route path="/test" element={<Test />} />
      <Route path="/insightscontainer" element={<InsightsContainer />} />
      <Route path="/applicant/candidates" element={<TestQuestion />} />
      <Route path="/testpreview" element={<TestPreview />} />
      {/* @ts-ignore */}
      <Route path="/testX27QF0rPxLljNoAq71sgROuRuJd0A40aApO_EALw_wcB=preview/:id" element={<TestLogin />} exact />
      {/* @ts-ignore */}
      <Route path="/test/thankyou/:id" element={<Thankyou />} exact />
      <Route path="/testquestionpreviewdetails" element={<TestQuestionPreviewDetails />} />
      <Route path="/roletable" element={<RoleTable />} />
      <Route path="/report" element={<Report />} />
      {/* @ts-ignore */}
      <Route path="/registertable" element={<RegisterTable headerTitles={[]} setData={undefined} />} exact />

    </Routes>
  )
}

export default AppRoutes;

